import { Enums } from './enums';

import { parse } from 'querystring';
import moment from 'moment';
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const isAntDesignPro = (): boolean => {
	if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
		return true;
	}
	return window.location.hostname === 'preview.pro.ant.design';
};

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
	const { NODE_ENV } = process.env;
	if (NODE_ENV === 'development') {
		return true;
	}
	return isAntDesignPro();
};

/**
 * 获取页面地址栏指定参数的值
 * @param {string} variable 参数名称
 */
export const getQueryVariable = (variable: any) => {
	const params = getPageQuery();
	if (params && params[variable])
		return params[variable];

	return null;
}

export const getPageQuery = () => {
	const { href } = window.location;
	const qsIndex = href.indexOf('?');
	const sharpIndex = href.indexOf('#');

	if (qsIndex !== -1) {
		if (qsIndex > sharpIndex) {
			return parse(href.split('?')[1]);
		}

		return parse(href.slice(qsIndex + 1, sharpIndex));
	}

	return {};
};
const menuMap = (data: string | any[], format: any) => {

	const dataMap = {};// 全数据映射
	const root = [];// 根
	for (let i = 0, len = data.length; i < len; i++) {
		const d = data[i];
		// 初始化child字段,如果不想要这里初始化也可以在树形填充出进行判断初始化
		d[format.child] = [];
		dataMap[d[format.id]] = d;
		if (data[i][format.pid] === format.root) {// 将root记录到root数组

			root.push(d);
		}
		// console.log('root',root)
	}
	return { dm: dataMap, root };
};
const menuSort = (result: any[], format: any) => {
	// console.log(result)
	if (!format.sort) return;// 没有排序配置则不进行排序
	result.sort(function (a, b) {
		const as = a[format.sort.field];
		const bs = b[format.sort.field];
		return (as - bs) * format.sort.direct;
	});
	// 如果result中有child，则继续进行排序
	for (let i = 0, len = result.length; i < len; i++) {
		if (result[i][format.child].length > 0) {
			menuSort(result[i][format.child], format);
		}
	}
};
export const menuFormat = (data: string | any[], format: { pid?: any; child: any; id?: string | number; root?: any; sort?: { field: string | number; direct: number; }; }) => {
	// console.log('menuFormat',data)
	if (!data || data.length <= 0) return data;
	const map = menuMap(data, format);
	// 再遍历原数据进行树形填充
	for (let i = 0, len = data.length; i < len; i++) {
		const d = data[i];
		if (map.dm[d[format.pid]]) {
			map.dm[d[format.pid]][format.child].push(d);
		}
	}
	// 最后将root排序后返回
	menuSort(map.root, format);
	return map.root;
};
// 固定列表结构：[{Id:'xxx',parentid:'xxx'}]
export const TreeHelper = {
	GetAllByTree(Flist: string | any[], result: any[]) {
		if (result.length === 0)
			result = [];
		for (let i: number = 0; i < Flist?.length; i += 1) {
			result.push(Flist[i]);
			if (Flist[i]?.children) {
				this.GetAllByTree(Flist[i]?.children, result);

			}
		}
		return result;

	},
	getParentIds(id: any, allNodes: string | any[]): any {
		const newSllNodes = this.GetAllByTree(allNodes, []);
		const parents = [];
		const theNode = this.findTheNode(id, newSllNodes);
		if (theNode?.parentid) {
			if (theNode.parentid != '0')
				parents.push(theNode.parentid);
			parents.push(...this.getParentIds(theNode.parentid, newSllNodes));
		}

		return parents;
	},
	getChildrenIds(id: any, allNodes: string | any[]) {
		const newSllNodes = this.GetAllByTree(allNodes, []);
		const childrenIds = [];
		const children = newSllNodes?.filter(item => item.parentid == id)
			.map(item => item.menuid);
		if (children?.length > 0) {
			childrenIds.push(...children);
			children.forEach(item => {
				childrenIds.push(...this.getChildrenIds(item, newSllNodes));
			});
		}
		return childrenIds;
	},
	findTheNode(id: any, allNodes: any[]) {
		return allNodes?.filter(item => item?.menuid == id)[0];
	}
};

export const CheckPermission = (key: string, initialState: any) => {
	const { currentUser } = initialState || {};
	return currentUser?.data?.permissionlist?.some((item: string) => item === key);
};
export const CheckPermissions = (key: string[], initialState: any) => {
	if (!key)
		return false;
	const { currentUser } = initialState || {};
	return currentUser?.data?.permissionlist?.some((item: string) => key.includes(item));
};
export const logger = (...params: any) => {
	if (process.env.NODE_ENV == 'development') {
		/* eslint-disable */
		console.log(...params);
	}

};
export const getSessionID = () => {
	return localStorage.getItem('sessionid') || '';
};
/**
 * 取出localStorage中包含有过期时间跟当前时间对比，如果比当前时间小就过期，如果大于等于当前时间则正常
 * 数据格式：{value:string,expire:Number}
 * @param key 
 * @returns 
 */
export const getLocalStorageByExpire = (key: string) => {
	const value = localStorage.getItem(key);
	if (value && value.indexOf('expire') >= 0) {
		const json = JSON.parse(value);
		if (json.expire >= new Date().getTime()) {
			return json.value
		} else {
			localStorage.removeItem(key);
			return null;
		}

	} else {
		localStorage.removeItem(key);
		return null;
	}
}
export const setLocalStorageByExpire = (key: string, value: string, expireDate: Date) => {
	const json = { value: value, expire: expireDate.getTime() };
	localStorage.setItem(key, JSON.stringify(json));
}
/**
 * 根据文件名（带扩展名）获取文件类型
 */
export function getFileType(fileName: string) {
	if (!fileName) return '';

	if (/(.*)\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|svg|jfif)$/i.test(fileName)) {
		return 'pic';
	}

	if (/(.*)\.(mp4)$/i.test(fileName)) {
		return 'video';
	}

	if (/(.*)\.(pdf)$/i.test(fileName)) {
		return 'pdf';
	}

	if (/(.*)\.(doc|docx)$/i.test(fileName)) {
		return 'doc';
	}

	if (/(.*)\.(xls|xlsx)$/i.test(fileName)) {
		return 'xls';
	}

	if (/(.*)\.(ppt|pptx)$/i.test(fileName)) {
		return 'ppt';
	}

	return '';
}
export function getUUID() {
	let outString: string = '';
	const inOptions: string = 'abcdefghijklmnopqrstuvwxyz0123456789';

	for (let i = 0; i < 32; i++) {

		outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));

	}

	return outString;
}

/**
 * 根据历度，换算单位
 * @param {历度} ld 
 * @param {时间字符串} date 
 */
export function conversionUnit(ld: any, date: any) {
	let result = date
	if (ld === '1')
		result = date.toString().substring(0, 13) + '点'
	if (ld === '2')
		result = date.toString().substring(0, 10)
	if (ld === '3')
		result = date.toString().substring(0, 7)
	if (ld === '4')
		result = date.toString().substring(0, 4)
	return result
}

/**
 * 获取保留位小数(向下截取，不做四舍五入)
 * @param {float} num 源数字
 * @param {int} fixNum 小数保留位数
 */
export function getFixedNum(num: any, fixNum: any) {
	if (!num || isNaN(num))
		return num;

	let fixed = 3;
	if (fixNum || fixNum >= 0) {
		fixed = fixNum;
	}

	const tenTimes = (num1: number) => {// 获取10的几何倍数
		let n = 1;
		for (let j = 1; j <= num1; j++) {
			n *= 10;
		}
		return n;
	};

	const numStr = `${num}`;
	const pointPosition = numStr.indexOf('.');
	if (pointPosition === -1) {// 没有小数点则直接返回原数字
		return num;
	}

	if (fixed === 0) {
		return (num >= 0) ? Math.floor(num) : Math.ceil(num); // 不需要保留小数位
	}

	if (fixed > 0) {
		const resultNum = numStr.substring(0, pointPosition + 1 + fixed); // 截取到保留位
		const floatNum = resultNum.substring(pointPosition + 1, numStr.length); // 取小数部分

		if (floatNum && parseInt(floatNum, 10) === 0) {// 小数部分为0，则直接返回整数
			return parseInt(resultNum, 10);
		}

		for (let i = fixed; i >= 1; i--) {
			if (parseInt(floatNum, 10) % tenTimes(i) === 0) {
				return resultNum.substring(0, pointPosition + 1 + (fixed - i));// 剔除小数点尾数为0的部分
			}
		}

		return resultNum;
	}

	return num;
}

/**
 * 特殊字符转义
   @param {*} str 待转义字符串
 */
export function specialCharConvert(str: any) {
	if (str.length == 0 || str.indexOf('&') === -1) // 不需要转义
		return str;

	const charArray = {// 转义字符配置
		'&sup3;': '³',
		'&sup2;': '²',
		'&middot;': '·',
		'&amp;': '&',
		'&uarr;': '↑',
		'&larr;': '←',
		'&rarr;': '→',
		'&darr;': '↓',
		'&le;': '≤',
		'&times;': '×',
	};
	let result = str;

	Object.keys(charArray)
		.forEach(key => {
			if (str.indexOf(key) !== -1) {
				result = result.replace(key, charArray[key]);
			}
		});

	return result;
}
/**
 * 把菜单展开
 * @param menuList 
 * @param result 
 * @returns 
 */
export function GetAllAction(menuList: string | any[], result: any[]) {
	if (result.length === 0)
		result = [];
	for (let i: number = 0; i < menuList?.length; i += 1) {
		// let tmpPath = result.concat();
		result.push(menuList[i]);
		if (menuList[i].children) {
			GetAllAction(menuList[i].children, result);
		}
	}
	return result;

};
//获取菜单所属系统
export function getMenuTypeByPath(menuList: string | any[], path: string) {
	const allMenu = GetAllAction(menuList, []);
	const current = allMenu.find(el => el.path == path);
	//不属于菜单返回空
	if (!current) {
		return null;
	}
	//顶级菜单直接返回
	if (current.parent == "0") {
		return Object.keys(Enums.indexMenuPath).find(key => Enums.indexMenuPath[key].path == current.path) || ''
	}
	//非顶级则查找父级
	const parent = allMenu.find(el => el.key == current.parent);
	if (!parent) {
		return null;
	}
	if (parent.parent == "0") {
		return Object.keys(Enums.indexMenuPath).find(key => Enums.indexMenuPath[key].path == parent.path) || ''
	} else {


		getMenuTypeByPath(menuList, parent.path);
	}
	return null;

}
//@ts-ignore
export function getLastMenuByPath(menu: { children: string | any[]; path: any; }) {


	if (menu.children.length == 0) {
		return menu.path;
	} else {
		return getLastMenuByPath(menu.children[0])
	}

}

//获取某月的最后一天 dateStr格式:'YYYY-MM-DD'
export function getMonthLastDate(dateStr: any) {

	let dateObj = new Date(dateStr);
	let nextMonth = dateObj.getMonth() + 1; //0-11，下一个月
	//设置当前日期为下个月的1号
	dateObj.setMonth(nextMonth);
	dateObj.setDate(1);  //1-31

	let nextMonthFirstDayTime = dateObj.getTime(); //下个月一号对应毫秒

	let theMonthLastDayTime = nextMonthFirstDayTime - 24 * 60 * 60 * 1000;  //下个月一号减去一天，正好是这个月最后一天

	let theMonthDay = (new Date(theMonthLastDayTime)).getDate();

	return moment(dateStr).format('YYYY-MM') + '-' + theMonthDay;
}
export function defaultseries(name, data, type) {

	return ({
		name,
		type: (type && type === 'bar') ? type : 'line',
		smooth: true,
		// areaStyle: {},
		data,
		symbolSize: 12,
		markPoint: {
			symbolSize: 80,
			label: {
				fontSize: 17
			},
			data: [
				{ type: 'max', name: '最大值' },
				{ type: 'min', name: '最小值' }
			]
		},
	})
}


/**
 * 根据时间展示数据
 * @param {*} sjcxtj 
 */
export function daythrough(sjcxtj: any) {
	let daykssj = moment(sjcxtj.kssj).startOf('d')
	let dayjssj = moment(sjcxtj.jssj).endOf('d')
	let daylist = []
	do {
		daylist.push(daykssj.format('YYYY-MM-DD'))
		daykssj = daykssj.add(1, 'd')
	} while (daykssj <= dayjssj);
	return daylist
}

/**
 * 返回24小时的5分钟刻度（288条）
 */
export function defaultMinute() {
	let result = []
	let minkssj = moment().startOf('day')
	let minjssj = moment(minkssj).add(1, 'd').subtract(5, 'm')
	do {
		// console.log(minkssj.format('HH:mm'))
		minkssj = minkssj.add(5, 'm') // 增加五分钟
		result.push(minkssj.format('HH:mm'))
	} while (minkssj < minjssj);
	result.push('24:00')
	return result
}



